// extracted by mini-css-extract-plugin
export var copyblock = "CopyBlock-module--copyblock--a0006";